import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectCountries } from '../store/selectors/commonSelectors';
import { selectPortalGatewayISOCodesListToIgnoreAreaCode } from '../store/selectors/settingsSelectors';
import { formatPhoneNumberForView } from '../util/helpers/phoneNumberHelpers';
import Paragraph from './Paragraph/Paragraph';
import themeColors from '../assets/styles/themeColors';
import MissingInfo from '../pages/Review/MisingInfo';

const PhoneFormat = ({ Phone }) => {
  const selectedISOCodesListToIgnoreAreaCode = useSelector(
    selectPortalGatewayISOCodesListToIgnoreAreaCode,
  );
  const countries = useSelector(selectCountries);
  const isEmptyPhone = !Phone || (Phone && !Phone?.Iso3CountryCode);

  if (isEmptyPhone) {
    return <MissingInfo />;
  }
  return (
    <Paragraph color={themeColors.colorTextXLLight} variant="normal">
      {Phone?.Iso3CountryCode &&
        formatPhoneNumberForView(
          Phone,
          countries,
          selectedISOCodesListToIgnoreAreaCode,
        )}
    </Paragraph>
  );
};

PhoneFormat.propTypes = {
  Phone: PropTypes.shape({
    Iso3CountryCode: PropTypes.string,
  }),
};

export default PhoneFormat;
